module.exports = __webpack_public_path__ + "images/store_case_study/andrecycle-pic2_434dba8356bfe6e3c6cc02d971fc00f5.jpg";